export default "__VITE_ASSET__B_71gf_9__"